import { PAYOUT_INTERVAL, PAYOUT_STATUSES } from '../../../../../../services/exports/Constants';

export default {
  headers: {
    payout_info: 'Udbetalingsinfo',
    payouts: 'Udbetalinger',
  },
  form: {
    invoicing_emails: {
      label: 'Send fakturaer til',
      placeholder: 'Indtast din e-mail',
    },
    payout_schedule: {
      label: 'Udbetalingsplan',
      options: {
        [PAYOUT_INTERVAL.MANUAL]: 'Sat på pause',
        [PAYOUT_INTERVAL.DAILY]: 'Daglige udbetalinger',
        [PAYOUT_INTERVAL.WEEKLY]: 'Ugentlige udbetalinger',
        [PAYOUT_INTERVAL.MONTHLY]: 'Månedlige udbetalinger',
      },
    },
  },
  fields: {
    id: 'ID',
    company: 'Restaurant',
    amount: 'Beløb',
    cash_amount: 'Kontantbeløb',
    paypal_standalone_amount: 'PayPal-beløb',
    period: 'Periode',
    paid_at: 'Betalt den',
    provider: 'Udbyder',
    status: 'Status',
    actions: 'Handlinger',
  },
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
    paypal: 'PayPal',
    paypal_standalone: 'PayPal',
    cash: 'Kontant',
    system: 'System',
  },
  buttons: {
    save: 'Gem',
    actions: 'Handlinger',
    open_report: 'Åbn rapport',
    open_tracking_url: 'Spor udbetaling',
  },
  statuses: {
    [PAYOUT_STATUSES.created]: 'Afventer',
    [PAYOUT_STATUSES.processing]: 'Behandles',
    [PAYOUT_STATUSES.paid]: 'Betalt',
    [PAYOUT_STATUSES.failed]: 'Mislykkedes',
    undefined: 'Ukendt',
    null: 'Ukendt',
  },
  toasts: {
    failed_to_load_data: 'Kunne ikke hente data',
    successfully_updated: 'Opdateret',
  },
};
